<!-- dev.vue -->
<template>
  <div class="dev-container">
    <h2>Gestione LocalStorage</h2>
    <p><strong>Stato operazione:</strong> {{ message }}</p>

    <div v-if="storageItems.length" class="storage-list">
      <h3>Elementi attuali in LocalStorage:</h3>
      <ul>
        <li v-for="item in storageItems" :key="item.key">
          <code>{{ item.key }}</code>: {{ item.value }}
        </li>
      </ul>
    </div>
    <p v-else>LocalStorage vuoto.</p>
  </div>
</template>

<script>
export default {
  name: 'DevStorage',
  data() {
    return {
      message: 'In elaborazione...',
      storageItems: []
    };
  },
  mounted() {
    this.refreshStorageList();
  },
  methods: {
    refreshStorageList() {
      const items = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        items.push({
          key,
          value: localStorage.getItem(key)
        });
      }
      this.storageItems = items;
    }
  }
};
</script>

<style scoped>
.dev-container {
  font-family: sans-serif;
  max-width: 600px;
  margin: 30px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.storage-list ul {
  list-style-type: none;
  padding: 0;
}
.storage-list li {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}
code {
  background: #f4f4f4;
  padding: 2px 5px;
  border-radius: 4px;
}
</style>